import { REQUIREMENT_DATA } from '../requirementData'
import { STATUS_COLORS, STATUS_BACKGROUND_COLORS } from '../theme'
import { STATUS_CATEGORIES } from './constants/statuses'

export const getStatusColor = (status) => {
  return STATUS_COLORS[status] || STATUS_COLORS.default
}

export const getStatusBackgroundColor = (status) => {
  return STATUS_BACKGROUND_COLORS[status] || STATUS_BACKGROUND_COLORS.default
}

export const getRequirementDisplayData = (levelKey, requirement) => {
  const levelData = REQUIREMENT_DATA[levelKey]
  if (!levelData) return null

  const reqData = levelData.requirements[requirement.id]
  if (!reqData) return null

  const statusData = reqData.statuses[requirement.status]
  if (!statusData) return null

  const baseStatusData = {
    name: reqData.name,
    color: getStatusColor(requirement.status),
    backgroundColor: getStatusBackgroundColor(requirement.status),
    ...statusData,
  }

  const { id, status, seminarRegistration } = requirement
  const isSeminarRequirement = id === 'seminar' || id === 'virtual_seminar'

  // Format seminar message with actual date if registered
  if (
    isSeminarRequirement &&
    status === 'registered' &&
    !!seminarRegistration?.eventStartDate
  ) {
    const { eventStartDate } = seminarRegistration

    // Date is set based on location already/should not factor in timezone
    const [year, month, day] = eventStartDate.split('-').map(Number)
    const date = new Date(year, month - 1, day)

    const formattedDate = date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })

    const dateText = !!eventStartDate ? `on ${formattedDate}` : ''
    const message = `Prepare for your seminar ${dateText} by reviewing the seminar manuals.`

    return {
      ...baseStatusData,
      message,
    }
  }

  return baseStatusData
}

export const getEnrollmentDate = (programHistory = []) => {
  if (!programHistory || programHistory.length === 0) return null

  const level1Program = programHistory.find(
    (program) => program.levelCode && program.levelCode.endsWith('1'),
  )

  if (!level1Program?.startDate) return null

  // Parse the date string: "YYYY-MM-DD" -> "M/D/YYYY"
  const [year, month, day] = level1Program.startDate.split('-')
  return `${parseInt(month)}/${parseInt(day)}/${year}`
}

export const isCompleteStatus = (status) => {
  return STATUS_CATEGORIES.COMPLETE.includes(status)
}

export const isInProgressStatus = (status) => {
  return STATUS_CATEGORIES.IN_PROGRESS.includes(status)
}

export const isLockedStatus = (status) => {
  return STATUS_CATEGORIES.LOCKED.includes(status)
}

export const isReadyStatus = (status) => {
  return STATUS_CATEGORIES.READY.includes(status)
}
